module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.29009",
      "ably": "static-2.2",
      "data-fetching-client": "static-1.9631",
      "ably-hubspot-js": "static-2.4674",
      "atom": "static-1.5029",
      "conversations-async-data": "static-2.7621",
      "conversations-error-reporting": "static-1.8839",
      "conversations-internal-pub-sub": "static-1.15930",
      "conversations-internal-schema": "static-1.12810",
      "conversations-message-history": "static-1.12534",
      "conversations-test-sdk": "static-1.10460",
      "conversations-visitor-experience-components": "static-1.22372",
      "head-dlb": "static-1.4938",
      "hs-promise-utils": "static-1.5550",
      "hs-test-utils": "static-1.7973",
      "hubspot-dlb": "static-2.1832",
      "HubStyleTokens": "static-2.11418",
      "I18n": "static-7.1612",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2975",
      "jasmine-runner": "static-1.6426",
      "quartz": "static-1.6963",
      "react-dlb": "static-1.78",
      "react-select-plus": "static-1.104",
      "react-transition-group": "static-2.64",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4429",
      "StyleGuideUI": "static-3.486",
      "transmute": "static-2.85",
      "urlinator": "static-1.4488",
      "usage-tracker": "static-1.7296",
      "usage-tracker-core": "static-1.7146",
      "usage-tracker-public": "static-1.7107",
      "viral-links-lib": "static-1.7012",
      "visitor-ui-component-library": "static-1.6096",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4766",
      "conversations-prop-types": "static-1.7408",
      "conversations-visitor-message-history": "static-1.21109",
      "cssUtils": "static-1.780",
      "enviro": "static-4.428",
      "flux-actions": "static-1.331",
      "foundations-components": "static-1.7844",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6178",
      "hubspot-url-utils": "static-1.4049",
      "immutable": "static-2.77",
      "metrics-js": "static-1.9542",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.388",
      "raven": "static-3.5829",
      "react": "static-7.185",
      "react-aria": "static-1.65",
      "react-dom": "static-7.85",
      "react-redux": "static-7.70",
      "react-rhumb": "static-1.16626",
      "react-utils": "static-2.5308",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.8100",
      "signup-constants": "static-1.18756",
      "styled-components": "static-2.88",
      "usage-tracker-multi": "static-1.5710",
      "visitor-ui-component-library-icons": "static-1.5907",
      "hs-promise-rejection-tracking": "static-1.5489",
      "raven-hubspot": "static-1.6136",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3367",
      "moment": "static-3.26",
      "apollo-stack-hubspot": "static-3.85",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.81",
      "quartz-config": "static-1.741",
      "quartz-core": "static-1.6182",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4813",
      "foundations-theming": "static-1.4373",
      "UIComponents": "static-3.8365",
      "customer-data-email": "static-1.17952",
      "cv-backend-services": "static-1.1551",
      "immutable-less": "static-1.4606",
      "conversations-skeleton-state": "static-1.7205",
      "crm-events-viz-core": "static-1.33030",
      "customer-data-objects": "static-1.7620",
      "icons": "static-2.644",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.4607",
      "ui-images": "static-2.1141",
      "HeadJS": "static-2.741",
      "framer-motion": "static-1.71",
      "hs-test-utils-bend-plugin": "static-1.3084",
      "msw": "static-1.39",
      "testing-library": "static-1.151",
      "i18n-data": "static-1.220",
      "moment-timezone": "static-5.82",
      "jasmine": "static-4.4281",
      "signup-ui-url-generator": "static-2.7997",
      "HubStyle": "static-2.11726",
      "quartz-i18n": "static-1.638",
      "sassPrefix": "static-1.155",
      "bend-plugin-foundations-components": "static-1.4113",
      "floating-ui": "static-1.55",
      "foundations-theming-specialty": "static-1.2089",
      "hs-story-utils": "static-1.9386",
      "react-create-root-preference": "static-1.11",
      "react-virtualized": "static-2.98",
      "tanstack-table": "static-1.54",
      "trellis-assets": "static-1.1707",
      "ui-fonts": "static-1.680",
      "hs-locale-management": "static-1.48",
      "csstype": "static-1.50",
      "quartz-head": "static-1.628",
      "quick-fetch": "static-1.3881",
      "web-vitals": "static-1.4",
      "quartz-routing": "static-1.393",
      "usage-tracker-anonymous": "static-1.5713",
      "bender-build-tools": "static-1.3123",
      "dispatcher": "static-1.135",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.827",
      "hubspotter-http": "static-1.4616",
      "mobile-manifest-mixins": "static-1.515",
      "module-federation": "static-1.22",
      "quartz-auth": "static-1.638",
      "quartz-test": "static-1.638",
      "quartz-tracking": "static-1.342",
      "usage-tracker-container": "static-1.7286",
      "bend-plugin-foundations-theming": "static-1.2856",
      "foundations-theming-base": "static-1.3358",
      "stylex": "static-1.32",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4605",
      "customer-data-ui-utilities": "static-1.9783",
      "FileManagerCore": "static-1.38985",
      "FileManagerLib": "static-1.39126",
      "hubspot-apollo-client": "static-1.4833",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.524",
      "timezone-utils": "static-2.5201",
      "ui-gdpr-components": "static-1.10304",
      "ts-schema": "static-1.4042",
      "ai-components-ui-library": "static-1.8812",
      "avatar-components": "static-1.2455",
      "content-assistance-lib": "static-1.7680",
      "crm-component-utils": "static-1.38949",
      "crm-display-components": "static-1.24699",
      "crm-fe-perf": "static-1.22860",
      "crm-links": "static-1.6240",
      "crm-message-bus": "static-1.42855",
      "crm-search-service-types": "static-1.1109",
      "crm-source-interpretation-lib": "static-1.5295",
      "customer-data-communicator": "static-1.45396",
      "customer-data-filters-ui": "static-1.39581",
      "customer-data-objects-ui-components": "static-1.12982",
      "customer-data-properties": "static-1.51377",
      "customer-data-rte": "static-1.32870",
      "draft-plugins": "static-2.21589",
      "file-manager-components": "static-1.23486",
      "framework-data-schema-resolvers": "static-1.6835",
      "frontend-preferences-client": "static-1.7884",
      "hubspot-prosemirror": "static-1.18097",
      "object-comments-thread-lib": "static-1.10521",
      "prosemirror-user-and-team-at-mentions": "static-1.490",
      "reference-resolvers-lite": "static-1.8052",
      "ui-addon-upgrades": "static-9.17922",
      "universal-associations-select": "static-1.10981",
      "universal-record-utils-lib": "static-1.736",
      "wootric-nps": "static-1.6942",
      "inbound-db-properties-service-client": "static-1.3805",
      "property-translator": "static-1.5358",
      "bend-plugin-chirp-manifest": "static-1.17",
      "chirp-fetch": "static-1.1842",
      "history": "static-4.47",
      "react-router-dom": "static-5.26",
      "hub-http-shared-msw-handlers": "static-1.9854",
      "hubspotter-http-shared-msw-handlers": "static-1.9852",
      "usage-tracker-session-replay": "static-1.4982",
      "react-dnd-compat": "static-1.4577",
      "audio-components": "static-1.5845",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29213",
      "FileManagerImages": "static-1.36637",
      "foundations-components-legacy": "static-1.869",
      "immerable": "static-1.4110",
      "ui-universal-auth": "static-1.8920",
      "video-components": "static-1.13112",
      "video-data-lib": "static-1.34767",
      "video-embed": "static-1.35601",
      "hubspot-apollo-cache": "static-1.292",
      "chatspot-core": "static-1.21055",
      "ContentUtils": "static-1.68221",
      "copilot-toolkit": "static-1.10990",
      "superstore": "static-1.4723",
      "ui-addon-video-player": "static-1.8655",
      "ui-coaching-tips": "static-1.28409",
      "card-properties-lib": "static-1.44028",
      "commerce-subscription-lib": "static-1.36958",
      "crm-actions": "static-1.6276",
      "crm-cards-sdk": "static-1.43436",
      "customer-data-properties-shared-msw-handlers": "static-1.9181",
      "customer-data-property-utils": "static-1.8040",
      "customer-data-tracking": "static-1.6842",
      "hs-resources": "static-1.105",
      "inbound-db-meta-service-client": "static-1.3555",
      "pulse": "static-1.518",
      "framework-data-table": "static-2.11811",
      "location-customization-utils-lib": "static-1.9100",
      "calling-error-reporting": "static-1.31264",
      "calling-internal-common": "static-1.31258",
      "calling-usage-tracker": "static-1.6499",
      "crm_data": "static-4.91801",
      "customer-data-content": "static-1.27192",
      "draft-content-plugins": "static-1.28138",
      "draft-convert": "static-2.72",
      "draft-extend": "static-3.74",
      "draft-js": "static-5.77",
      "draft-signature-plugin": "static-1.23941",
      "EmailSignatureEditor": "static-1.24272",
      "hubspot-prosemirror-plugins": "static-1.18089",
      "integration-settings-components": "static-1.15329",
      "integrations-lib": "static-1.15962",
      "integrations-tracking-lib": "static-1.5555",
      "native-integrations-shared-strings": "static-1.7740",
      "nav-meta": "static-1.29508",
      "onboarding-scopes": "static-1.6419",
      "outreach-assistant-email-generation": "static-1.6115",
      "prosemirror-copilot": "static-1.11481",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.37901",
      "react-colorpicker": "static-2.10167",
      "reference-resolvers": "static-1.8127",
      "rich-text-lib": "static-1.19749",
      "sales-email-signature-service-client": "static-1.3800",
      "sequences-lib": "static-1.7959",
      "ui-addon-i18n": "static-1.11107",
      "ui-addon-iframeable": "static-1.9012",
      "ui-business-units-lib": "static-1.9005",
      "ui-shepherd-react": "static-3.10105",
      "user-context": "static-1.5058",
      "whatsapp-sending-lib": "static-1.5511",
      "customer-data-filters-ui-msw-helpers": "static-1.22016",
      "customer-data-reference-ui-components": "static-1.13116",
      "FormUrlGenerator": "static-2.4676",
      "framework-builder-read-service-client": "static-1.3974",
      "framework-data-schema-quick-fetch": "static-1.6740",
      "multi-account-reference-resolvers": "static-1.936",
      "onboarding-tours": "static-1.16508",
      "reporting-datasets-permissions-lib": "static-1.13532",
      "SharedI18nStrings": "static-1.182",
      "ui-addon-teams": "static-1.21488",
      "calling-global-api": "static-1.64342",
      "calling-lifecycle-internal": "static-1.65724",
      "calling-lifecycle-messages": "static-1.58018",
      "commerce-products-lib": "static-1.9350",
      "conditional-properties-service-client": "static-1.3761",
      "external-options-client-types": "static-1.4123",
      "google-libphonenumber": "static-1.37",
      "inbounddb-objects-service-types": "static-1.4188",
      "meetings-icalendar-utils-lib": "static-1.588",
      "multi-currency-client-types": "static-1.3656",
      "object-builder-ui-client": "static-1.48570",
      "pipeline-validation-client-types": "static-1.3930",
      "property-value-citations": "static-1.1991",
      "smart-property-lib": "static-1.6688",
      "tiered-pricing": "static-1.1113",
      "ui-addon-form-validation": "static-1.10945",
      "video-components-external": "static-1.11109",
      "batch-promise": "static-1.1507",
      "crm-pipelines-api-client-types": "static-1.4107",
      "persist-promise": "static-1.3664",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.25224",
      "knowledge-content-types": "static-1.8479",
      "payment-link-components": "static-1.23396",
      "ui-addon-emoji-picker": "static-1.9845",
      "call-summary": "static-1.39032",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.10000",
      "laboratory-lib": "static-3.7115",
      "merchandise-lib": "static-1.262",
      "purchase-motions-components": "static-1.5800",
      "crm-object-search-query-utilities": "static-1.9471",
      "amplitude-session-replay-browser": "static-1.59",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "unified-auth-core-lib": "static-1.715",
      "content-icons-ui": "static-1.2214",
      "social-insights-client-types": "static-1.21953",
      "outpost": "static-1.4144",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4768",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5532",
      "magpie-types": "static-1.4992",
      "simple-logging-lib": "static-1.3006",
      "growth-onboarding-feedback-components": "static-1.6540",
      "customer-data-sidebar": "static-2.45863",
      "enrichment-properties-lib": "static-1.15806",
      "commerce-billing-lib": "static-1.18925",
      "commerce-shared-components-lib": "static-1.18381",
      "commerce-tools-ui-lib": "static-1.10245",
      "bend-plugin-pulse": "static-1.21",
      "directed-graph": "static-1.892",
      "event-emitter": "static-1.905",
      "fast-json-patch": "static-1.62",
      "customer-data-associations": "static-1.7282",
      "deal-intel-decorators": "static-1.1848",
      "reporting-data": "static-1.67319",
      "tanstack-virtual": "static-1.29",
      "ui-addon-draggable": "static-3.4726",
      "crm-record-cards-service-types": "static-1.3574",
      "self-service-api": "static-1.10202",
      "crm_universal": "static-1.21925",
      "SalesContentIndexUI": "static-3.9175",
      "content-embed-lib": "static-1.7296",
      "data-model-builder-lib": "static-1.12174",
      "remote-ui": "static-1.64",
      "ui-components-test-utils": "static-1.5556",
      "ui-extensions-remote-renderer": "static-1.16875",
      "universal-page-editor-lib": "static-1.2969",
      "integrations-error-boundary-lib": "static-1.13377",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10328",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.434",
      "messaging-types-lib": "static-1.45857",
      "ai-addon-copilot-preview": "static-1.8024",
      "copilot-plugins": "static-1.10963",
      "data-token-picker": "static-1.16323",
      "sequences-client-types-lib": "static-1.7816",
      "foundations-components-test-utils": "static-1.5327",
      "navigation-messaging": "static-1.7198",
      "getting-started-shared-tasks": "static-1.18359",
      "getting-started-shared-tasks-store": "static-1.17477",
      "onboarding-tours-utils": "static-1.574",
      "messaging-usage-based-billing-components-lib": "static-1.982",
      "whatsapp-management-lib": "static-1.8670",
      "growth-data-modal": "static-1.5353",
      "growth-onboarding-confetti": "static-1.3024",
      "growth-onboarding-next-action-utils": "static-1.1771",
      "navigation-components": "static-1.17871",
      "onboarding-tours-client": "static-1.4722",
      "ui-shepherd-tracker": "static-1.7486",
      "shared-worker-versioning": "static-1.10994",
      "voice-sms-access-library": "static-1.790",
      "commerce-permissions": "static-1.722",
      "products-iframe-lib": "static-1.7787",
      "products-ui-components-shared-msw-handlers": "static-1.10236",
      "data-agent-kit": "static-1.119",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9937",
      "fsm": "static-1.3689",
      "policy-lib": "static-1.6729",
      "react-tinymce": "static-1.55103",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.54229",
      "tinymce-plugins": "static-1.57343",
      "tinymce-themes": "static-1.56199",
      "content-media-composition-data-lib": "static-1.12088",
      "content-media-compositions": "static-2.16095",
      "idb-keyval": "static-1.43",
      "media-bridge-lib": "static-1.18845",
      "ui-addon-opt": "static-4.8330",
      "commerce-tours-lib": "static-1.6008",
      "growth-onboarding-reliability": "static-1.5038",
      "sales-checkout-service-client": "static-1.3596",
      "calling-cross-tab-library": "static-1.19234",
      "calling-lifecycle-usage-tracker": "static-1.8569",
      "purchase-motions-api": "static-1.5803",
      "trials-service-types": "static-1.3860",
      "reactive-lib": "static-1.678",
      "card-payment-highlight-lib": "static-1.37023",
      "card-subscription-highlight-lib": "static-1.39381",
      "commerce-contract-lib": "static-1.11877",
      "invoices-highlight-card-lib": "static-1.54556",
      "orders-highlight-card-lib": "static-1.21324",
      "products-highlight-card-lib": "static-1.17634",
      "quotes-highlight-card-lib": "static-1.71811",
      "usage-based-billing-components-lib": "static-1.8633",
      "utility-belt": "static-1.2494",
      "payments-enrollment-embed-lib": "static-1.22543",
      "stripe-embedded-components": "static-1.7420",
      "growth-onboarding-empty-states": "static-1.5633",
      "InboxConnectUtils": "static-4.14665",
      "payments-post-enroll-local-storage-lib": "static-1.5066",
      "qrcode-generator": "static-1.68",
      "deal-intel-utils": "static-1.1852",
      "storybook-react": "static-1.32",
      "reporting-client-types": "static-1.2471",
      "react-flip-move": "static-1.69",
      "FireAlarmUi": "static-1.4478",
      "sales-templates-service-types-lib": "static-1.4132",
      "ui-asset-management-lib": "static-1.10966",
      "association-settings-lib": "static-1.10145",
      "collaboration-sidebar": "static-1.57649",
      "conditional-property-settings-modal": "static-1.12355",
      "data-model-commons-lib": "static-1.12438",
      "final-form": "static-1.69",
      "html-to-image": "static-1.53",
      "nudge-client-utils": "static-1.2458",
      "object-definition-builder-lib": "static-1.7045",
      "property-management-iframe": "static-1.12992",
      "property-usages-lib": "static-1.5383",
      "reactflow": "static-1.63",
      "simple-data-table": "static-1.2640",
      "used-in-list-lib": "static-1.6900",
      "visual-association": "static-1.5828",
      "highcharts": "static-8.103",
      "reporting-visualizations": "static-1.59395",
      "ui-extensibility-client-types": "static-1.3886",
      "google-sheets-integration-lib": "static-1.93",
      "microsoft-drive-integration-lib": "static-1.207",
      "automation-platform-service-types": "static-1.2565",
      "ContentData": "static-1.68296",
      "email-portal-health-service-types": "static-1.933",
      "marketing-email-service-types": "static-1.1891",
      "ai-rendering-library": "static-1.9934",
      "ai-settings-ui-library": "static-1.7809",
      "ui-brand-identity-lib": "static-1.15033",
      "messaging-shared-utils-lib": "static-1.431",
      "messaging-user-info-utils-lib": "static-1.601",
      "content-whatsapp-service-types": "static-1.360",
      "marketing-platform-lib": "static-1.6808",
      "short-messages-app-service-client": "static-1.3938",
      "ui-tool-access": "static-1.10106",
      "onboarding-data-sync-lib": "static-1.1884",
      "growth-onboarding-next-action-components": "static-1.1799",
      "user-context-client": "static-1.4567",
      "nest": "static-1.184",
      "calling-orchestration-schema": "static-1.35567",
      "sales-views-client-types": "static-1.4221",
      "trellis-story-utils": "static-1.4472",
      "hub-http-contrib": "static-1.2997",
      "interframe": "static-3.4718",
      "tinymce-data": "static-1.40314",
      "ui-addon-sales-email": "static-1.5167",
      "codemirror": "static-5.94",
      "layout-dnd-components": "static-1.12353",
      "layout-dnd-utils": "static-1.11328",
      "react-codemirror": "static-1.10580",
      "NamespacedHubStyle": "static-2.9027",
      "js-cookie": "static-1.18",
      "products-ui-components": "static-1.39869",
      "zustand": "static-1.74",
      "accounting-integrations-ui-components": "static-1.6987",
      "invoices-ui-lib": "static-1.54572",
      "commerce-products-api": "static-1.2220",
      "invoices-iframe-lib": "static-1.56630",
      "quotes-modal-lib": "static-1.102489",
      "quotes-ui-lib": "static-1.80532",
      "platform-infra-nav-components": "static-1.7637",
      "reporting-ui-components": "static-2.64590",
      "subscription-experience-data-types": "static-1.14855",
      "marketplace-ui-apps-core": "static-1.18064",
      "stripe-connect-js": "static-1.67",
      "ui-addon-react-router-dom": "static-1.9502",
      "nested-table": "static-1.182",
      "chatspot-widget-iframe": "static-1.21046",
      "collaboration-sidebar-common": "static-1.2446",
      "crm-properties-common-lib": "static-1.5833",
      "ui-addon-draggable-compat": "static-2.4211",
      "nudge-custom-function-registry": "static-1.2215",
      "nudge-renderer-utils": "static-1.2534",
      "whisper-core-api": "static-1.6467",
      "property-management-common": "static-1.5280",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.15054",
      "advanced-menus-lib": "static-1.12005",
      "ExportDialog": "static-6.10350",
      "ui-memberships-settings-lib": "static-1.33913",
      "embedded-academy-lib": "static-1.14174",
      "highlight.js": "static-1.78",
      "reporting-action-components": "static-1.41170",
      "reporting-snowflake": "static-1.55937",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9653",
      "browser-eslint": "static-2.57",
      "commerce-tax-lib": "static-1.480",
      "price-books-api": "static-1.470",
      "price-books-components": "static-1.528",
      "property-description-translator": "static-1.3803",
      "ramp-editor": "static-1.47",
      "commerce-analytics-service-client": "static-1.3584",
      "totals-ui-components": "static-1.23447",
      "reporting-plugins": "static-1.10213",
      "reporting-reports": "static-1.66997",
      "edison-service-client-types": "static-1.343",
      "developer-experience-shared-components": "static-1.10466",
      "marketplace-ui-client-types": "static-1.16938",
      "marketplace-ui-common": "static-1.19531",
      "ui-addon-integrations-directory-panel": "static-2.7953",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.130",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.15053",
      "simple-menus-lib": "static-1.16570",
      "academy-common-lib": "static-1.13634",
      "dashboard-lib": "static-1.81332",
      "share-with-third-party-component-lib": "static-1.8654",
      "line-items-api": "static-1.621",
      "commerce-totals-service-types": "static-1.3783",
      "campaign-roi-lib": "static-1.8933",
      "apps-service-types": "static-1.3834",
      "oauth-service-types": "static-1.4206",
      "academy-service-client": "static-1.3639",
      "croppie": "static-2.10",
      "trellis-ecosystem": "static-1.7048",
      "redux-actions": "static-3.7"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.29009",
      "ably": "/ably/static-2.2",
      "data-fetching-client": "/data-fetching-client/static-1.9631",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4674",
      "atom": "/atom/static-1.5029",
      "conversations-async-data": "/conversations-async-data/static-2.7621",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8839",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15930",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12810",
      "conversations-message-history": "/conversations-message-history/static-1.12534",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10460",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.22372",
      "head-dlb": "/head-dlb/static-1.4938",
      "hs-promise-utils": "/hs-promise-utils/static-1.5550",
      "hs-test-utils": "/hs-test-utils/static-1.7973",
      "hubspot-dlb": "/hubspot-dlb/static-2.1832",
      "HubStyleTokens": "/HubStyleTokens/static-2.11418",
      "I18n": "/I18n/static-7.1612",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2975",
      "jasmine-runner": "/jasmine-runner/static-1.6426",
      "quartz": "/quartz/static-1.6963",
      "react-dlb": "/react-dlb/static-1.78",
      "react-select-plus": "/react-select-plus/static-1.104",
      "react-transition-group": "/react-transition-group/static-2.64",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4429",
      "StyleGuideUI": "/StyleGuideUI/static-3.486",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4488",
      "usage-tracker": "/usage-tracker/static-1.7296",
      "usage-tracker-core": "/usage-tracker-core/static-1.7146",
      "usage-tracker-public": "/usage-tracker-public/static-1.7107",
      "viral-links-lib": "/viral-links-lib/static-1.7012",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6096",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4766",
      "conversations-prop-types": "/conversations-prop-types/static-1.7408",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.21109",
      "cssUtils": "/cssUtils/static-1.780",
      "enviro": "/enviro/static-4.428",
      "flux-actions": "/flux-actions/static-1.331",
      "foundations-components": "/foundations-components/static-1.7844",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6178",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
      "immutable": "/immutable/static-2.77",
      "metrics-js": "/metrics-js/static-1.9542",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.388",
      "raven": "/raven/static-3.5829",
      "react": "/react/static-7.185",
      "react-aria": "/react-aria/static-1.65",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.70",
      "react-rhumb": "/react-rhumb/static-1.16626",
      "react-utils": "/react-utils/static-2.5308",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.8100",
      "signup-constants": "/signup-constants/static-1.18756",
      "styled-components": "/styled-components/static-2.88",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5710",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5907",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
      "raven-hubspot": "/raven-hubspot/static-1.6136",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3367",
      "moment": "/moment/static-3.26",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.81",
      "quartz-config": "/quartz-config/static-1.741",
      "quartz-core": "/quartz-core/static-1.6182",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4813",
      "foundations-theming": "/foundations-theming/static-1.4373",
      "UIComponents": "/UIComponents/static-3.8365",
      "customer-data-email": "/customer-data-email/static-1.17952",
      "cv-backend-services": "/cv-backend-services/static-1.1551",
      "immutable-less": "/immutable-less/static-1.4606",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7205",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.33030",
      "customer-data-objects": "/customer-data-objects/static-1.7620",
      "icons": "/icons/static-2.644",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.4607",
      "ui-images": "/ui-images/static-2.1141",
      "HeadJS": "/HeadJS/static-2.741",
      "framer-motion": "/framer-motion/static-1.71",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3084",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.151",
      "i18n-data": "/i18n-data/static-1.220",
      "moment-timezone": "/moment-timezone/static-5.82",
      "jasmine": "/jasmine/static-4.4281",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7997",
      "HubStyle": "/HubStyle/static-2.11726",
      "quartz-i18n": "/quartz-i18n/static-1.638",
      "sassPrefix": "/sassPrefix/static-1.155",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4113",
      "floating-ui": "/floating-ui/static-1.55",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2089",
      "hs-story-utils": "/hs-story-utils/static-1.9386",
      "react-create-root-preference": "/react-create-root-preference/static-1.11",
      "react-virtualized": "/react-virtualized/static-2.98",
      "tanstack-table": "/tanstack-table/static-1.54",
      "trellis-assets": "/trellis-assets/static-1.1707",
      "ui-fonts": "/ui-fonts/static-1.680",
      "hs-locale-management": "/hs-locale-management/static-1.48",
      "csstype": "/csstype/static-1.50",
      "quartz-head": "/quartz-head/static-1.628",
      "quick-fetch": "/quick-fetch/static-1.3881",
      "web-vitals": "/web-vitals/static-1.4",
      "quartz-routing": "/quartz-routing/static-1.393",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5713",
      "bender-build-tools": "/bender-build-tools/static-1.3123",
      "dispatcher": "/dispatcher/static-1.135",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.827",
      "hubspotter-http": "/hubspotter-http/static-1.4616",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.515",
      "module-federation": "/module-federation/static-1.22",
      "quartz-auth": "/quartz-auth/static-1.638",
      "quartz-test": "/quartz-test/static-1.638",
      "quartz-tracking": "/quartz-tracking/static-1.342",
      "usage-tracker-container": "/usage-tracker-container/static-1.7286",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2856",
      "foundations-theming-base": "/foundations-theming-base/static-1.3358",
      "stylex": "/stylex/static-1.32",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4605",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9783",
      "FileManagerCore": "/FileManagerCore/static-1.38985",
      "FileManagerLib": "/FileManagerLib/static-1.39126",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4833",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.524",
      "timezone-utils": "/timezone-utils/static-2.5201",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10304",
      "ts-schema": "/ts-schema/static-1.4042",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8812",
      "avatar-components": "/avatar-components/static-1.2455",
      "content-assistance-lib": "/content-assistance-lib/static-1.7680",
      "crm-component-utils": "/crm-component-utils/static-1.38949",
      "crm-display-components": "/crm-display-components/static-1.24699",
      "crm-fe-perf": "/crm-fe-perf/static-1.22860",
      "crm-links": "/crm-links/static-1.6240",
      "crm-message-bus": "/crm-message-bus/static-1.42855",
      "crm-search-service-types": "/crm-search-service-types/static-1.1109",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5295",
      "customer-data-communicator": "/customer-data-communicator/static-1.45396",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39581",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12982",
      "customer-data-properties": "/customer-data-properties/static-1.51377",
      "customer-data-rte": "/customer-data-rte/static-1.32870",
      "draft-plugins": "/draft-plugins/static-2.21589",
      "file-manager-components": "/file-manager-components/static-1.23486",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6835",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7884",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18097",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.10521",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.490",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8052",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17922",
      "universal-associations-select": "/universal-associations-select/static-1.10981",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.736",
      "wootric-nps": "/wootric-nps/static-1.6942",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3805",
      "property-translator": "/property-translator/static-1.5358",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.17",
      "chirp-fetch": "/chirp-fetch/static-1.1842",
      "history": "/history/static-4.47",
      "react-router-dom": "/react-router-dom/static-5.26",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9854",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9852",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4982",
      "react-dnd-compat": "/react-dnd-compat/static-1.4577",
      "audio-components": "/audio-components/static-1.5845",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29213",
      "FileManagerImages": "/FileManagerImages/static-1.36637",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.869",
      "immerable": "/immerable/static-1.4110",
      "ui-universal-auth": "/ui-universal-auth/static-1.8920",
      "video-components": "/video-components/static-1.13112",
      "video-data-lib": "/video-data-lib/static-1.34767",
      "video-embed": "/video-embed/static-1.35601",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.292",
      "chatspot-core": "/chatspot-core/static-1.21055",
      "ContentUtils": "/ContentUtils/static-1.68221",
      "copilot-toolkit": "/copilot-toolkit/static-1.10990",
      "superstore": "/superstore/static-1.4723",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8655",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28409",
      "card-properties-lib": "/card-properties-lib/static-1.44028",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36958",
      "crm-actions": "/crm-actions/static-1.6276",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.43436",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9181",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8040",
      "customer-data-tracking": "/customer-data-tracking/static-1.6842",
      "hs-resources": "/hs-resources/static-1.105",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3555",
      "pulse": "/pulse/static-1.518",
      "framework-data-table": "/framework-data-table/static-2.11811",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9100",
      "calling-error-reporting": "/calling-error-reporting/static-1.31264",
      "calling-internal-common": "/calling-internal-common/static-1.31258",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6499",
      "crm_data": "/crm_data/static-4.91801",
      "customer-data-content": "/customer-data-content/static-1.27192",
      "draft-content-plugins": "/draft-content-plugins/static-1.28138",
      "draft-convert": "/draft-convert/static-2.72",
      "draft-extend": "/draft-extend/static-3.74",
      "draft-js": "/draft-js/static-5.77",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.23941",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24272",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18089",
      "integration-settings-components": "/integration-settings-components/static-1.15329",
      "integrations-lib": "/integrations-lib/static-1.15962",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5555",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7740",
      "nav-meta": "/nav-meta/static-1.29508",
      "onboarding-scopes": "/onboarding-scopes/static-1.6419",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.6115",
      "prosemirror-copilot": "/prosemirror-copilot/static-1.11481",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.37901",
      "react-colorpicker": "/react-colorpicker/static-2.10167",
      "reference-resolvers": "/reference-resolvers/static-1.8127",
      "rich-text-lib": "/rich-text-lib/static-1.19749",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3800",
      "sequences-lib": "/sequences-lib/static-1.7959",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11107",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9012",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.9005",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10105",
      "user-context": "/user-context/static-1.5058",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.5511",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22016",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13116",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4676",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3974",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6740",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.936",
      "onboarding-tours": "/onboarding-tours/static-1.16508",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13532",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "ui-addon-teams": "/ui-addon-teams/static-1.21488",
      "calling-global-api": "/calling-global-api/static-1.64342",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65724",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58018",
      "commerce-products-lib": "/commerce-products-lib/static-1.9350",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3761",
      "external-options-client-types": "/external-options-client-types/static-1.4123",
      "google-libphonenumber": "/google-libphonenumber/static-1.37",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4188",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.588",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3656",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.48570",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3930",
      "property-value-citations": "/property-value-citations/static-1.1991",
      "smart-property-lib": "/smart-property-lib/static-1.6688",
      "tiered-pricing": "/tiered-pricing/static-1.1113",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10945",
      "video-components-external": "/video-components-external/static-1.11109",
      "batch-promise": "/batch-promise/static-1.1507",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4107",
      "persist-promise": "/persist-promise/static-1.3664",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.25224",
      "knowledge-content-types": "/knowledge-content-types/static-1.8479",
      "payment-link-components": "/payment-link-components/static-1.23396",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9845",
      "call-summary": "/call-summary/static-1.39032",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10000",
      "laboratory-lib": "/laboratory-lib/static-3.7115",
      "merchandise-lib": "/merchandise-lib/static-1.262",
      "purchase-motions-components": "/purchase-motions-components/static-1.5800",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9471",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.715",
      "content-icons-ui": "/content-icons-ui/static-1.2214",
      "social-insights-client-types": "/social-insights-client-types/static-1.21953",
      "outpost": "/outpost/static-1.4144",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4768",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5532",
      "magpie-types": "/magpie-types/static-1.4992",
      "simple-logging-lib": "/simple-logging-lib/static-1.3006",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6540",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.45863",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15806",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18925",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18381",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10245",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.21",
      "directed-graph": "/directed-graph/static-1.892",
      "event-emitter": "/event-emitter/static-1.905",
      "fast-json-patch": "/fast-json-patch/static-1.62",
      "customer-data-associations": "/customer-data-associations/static-1.7282",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.1848",
      "reporting-data": "/reporting-data/static-1.67319",
      "tanstack-virtual": "/tanstack-virtual/static-1.29",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4726",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3574",
      "self-service-api": "/self-service-api/static-1.10202",
      "crm_universal": "/crm_universal/static-1.21925",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9175",
      "content-embed-lib": "/content-embed-lib/static-1.7296",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.12174",
      "remote-ui": "/remote-ui/static-1.64",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5556",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.16875",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2969",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13377",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10328",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.434",
      "messaging-types-lib": "/messaging-types-lib/static-1.45857",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.8024",
      "copilot-plugins": "/copilot-plugins/static-1.10963",
      "data-token-picker": "/data-token-picker/static-1.16323",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7816",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5327",
      "navigation-messaging": "/navigation-messaging/static-1.7198",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18359",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17477",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.574",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.982",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.8670",
      "growth-data-modal": "/growth-data-modal/static-1.5353",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3024",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1771",
      "navigation-components": "/navigation-components/static-1.17871",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4722",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7486",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10994",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.790",
      "commerce-permissions": "/commerce-permissions/static-1.722",
      "products-iframe-lib": "/products-iframe-lib/static-1.7787",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10236",
      "data-agent-kit": "/data-agent-kit/static-1.119",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9937",
      "fsm": "/fsm/static-1.3689",
      "policy-lib": "/policy-lib/static-1.6729",
      "react-tinymce": "/react-tinymce/static-1.55103",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.54229",
      "tinymce-plugins": "/tinymce-plugins/static-1.57343",
      "tinymce-themes": "/tinymce-themes/static-1.56199",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12088",
      "content-media-compositions": "/content-media-compositions/static-2.16095",
      "idb-keyval": "/idb-keyval/static-1.43",
      "media-bridge-lib": "/media-bridge-lib/static-1.18845",
      "ui-addon-opt": "/ui-addon-opt/static-4.8330",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.6008",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5038",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3596",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19234",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.8569",
      "purchase-motions-api": "/purchase-motions-api/static-1.5803",
      "trials-service-types": "/trials-service-types/static-1.3860",
      "reactive-lib": "/reactive-lib/static-1.678",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37023",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39381",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.11877",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54556",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21324",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17634",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71811",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8633",
      "utility-belt": "/utility-belt/static-1.2494",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22543",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7420",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5633",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.14665",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5066",
      "qrcode-generator": "/qrcode-generator/static-1.68",
      "deal-intel-utils": "/deal-intel-utils/static-1.1852",
      "storybook-react": "/storybook-react/static-1.32",
      "reporting-client-types": "/reporting-client-types/static-1.2471",
      "react-flip-move": "/react-flip-move/static-1.69",
      "FireAlarmUi": "/FireAlarmUi/static-1.4478",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4132",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10966",
      "association-settings-lib": "/association-settings-lib/static-1.10145",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.57649",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.12355",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.12438",
      "final-form": "/final-form/static-1.69",
      "html-to-image": "/html-to-image/static-1.53",
      "nudge-client-utils": "/nudge-client-utils/static-1.2458",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.7045",
      "property-management-iframe": "/property-management-iframe/static-1.12992",
      "property-usages-lib": "/property-usages-lib/static-1.5383",
      "reactflow": "/reactflow/static-1.63",
      "simple-data-table": "/simple-data-table/static-1.2640",
      "used-in-list-lib": "/used-in-list-lib/static-1.6900",
      "visual-association": "/visual-association/static-1.5828",
      "highcharts": "/highcharts/static-8.103",
      "reporting-visualizations": "/reporting-visualizations/static-1.59395",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3886",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.93",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.207",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2565",
      "ContentData": "/ContentData/static-1.68296",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.933",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1891",
      "ai-rendering-library": "/ai-rendering-library/static-1.9934",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7809",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15033",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.431",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.601",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.360",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6808",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3938",
      "ui-tool-access": "/ui-tool-access/static-1.10106",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1884",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1799",
      "user-context-client": "/user-context-client/static-1.4567",
      "nest": "/nest/static-1.184",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35567",
      "sales-views-client-types": "/sales-views-client-types/static-1.4221",
      "trellis-story-utils": "/trellis-story-utils/static-1.4472",
      "hub-http-contrib": "/hub-http-contrib/static-1.2997",
      "interframe": "/interframe/static-3.4718",
      "tinymce-data": "/tinymce-data/static-1.40314",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5167",
      "codemirror": "/codemirror/static-5.94",
      "layout-dnd-components": "/layout-dnd-components/static-1.12353",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.11328",
      "react-codemirror": "/react-codemirror/static-1.10580",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9027",
      "js-cookie": "/js-cookie/static-1.18",
      "products-ui-components": "/products-ui-components/static-1.39869",
      "zustand": "/zustand/static-1.74",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6987",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.54572",
      "commerce-products-api": "/commerce-products-api/static-1.2220",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56630",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.102489",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.80532",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7637",
      "reporting-ui-components": "/reporting-ui-components/static-2.64590",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14855",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18064",
      "stripe-connect-js": "/stripe-connect-js/static-1.67",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9502",
      "nested-table": "/nested-table/static-1.182",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21046",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2446",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5833",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4211",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2215",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2534",
      "whisper-core-api": "/whisper-core-api/static-1.6467",
      "property-management-common": "/property-management-common/static-1.5280",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.15054",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.12005",
      "ExportDialog": "/ExportDialog/static-6.10350",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33913",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.14174",
      "highlight.js": "/highlight.js/static-1.78",
      "reporting-action-components": "/reporting-action-components/static-1.41170",
      "reporting-snowflake": "/reporting-snowflake/static-1.55937",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9653",
      "browser-eslint": "/browser-eslint/static-2.57",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.480",
      "price-books-api": "/price-books-api/static-1.470",
      "price-books-components": "/price-books-components/static-1.528",
      "property-description-translator": "/property-description-translator/static-1.3803",
      "ramp-editor": "/ramp-editor/static-1.47",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3584",
      "totals-ui-components": "/totals-ui-components/static-1.23447",
      "reporting-plugins": "/reporting-plugins/static-1.10213",
      "reporting-reports": "/reporting-reports/static-1.66997",
      "edison-service-client-types": "/edison-service-client-types/static-1.343",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10466",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16938",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.19531",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7953",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.130",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.15053",
      "simple-menus-lib": "/simple-menus-lib/static-1.16570",
      "academy-common-lib": "/academy-common-lib/static-1.13634",
      "dashboard-lib": "/dashboard-lib/static-1.81332",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8654",
      "line-items-api": "/line-items-api/static-1.621",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3783",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.8933",
      "apps-service-types": "/apps-service-types/static-1.3834",
      "oauth-service-types": "/oauth-service-types/static-1.4206",
      "academy-service-client": "/academy-service-client/static-1.3639",
      "croppie": "/croppie/static-2.10",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.7048",
      "redux-actions": "/redux-actions/static-3.7"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.29009",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};